import { useEffect, useMemo, useState } from "react";
import { BiChevronLeft, BiChevronRight, BiMailSend } from "react-icons/bi";
import { BiExport, BiImport } from "react-icons/bi";
import { BsSearch } from "react-icons/bs";
import axios from "axios";
import useField from "../../../customHooks/useField";
import { getEmployees, resetEmployeeStatus } from "../../../store/employee";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
// import Footertable from "./footerTable";
import Oneempleyee from "./oneEmpleyee";
import Skeletontable from "./skeletonTable";
import Swal from "sweetalert2";
import { getAllCampaigns } from "../../../store/campaign";
import FileImport from "./import/ImportEmployees";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";
import { getRoles } from "../../../store/roles_skills";
import SendInviteButton from "./SendInviteButton";
//import { useNavigate } from "react-router";

const Employee = () => {
  const { isShown: isModalShown, toggle: ToggleModal } = useModal();

  const { token, skills } = useAppSelector((state) => state.user);

  const search = useField({
    type: "text",
    name: "search",
    placeholder: "Search User by Name or Email",
  });

  const [itemsPerPage, setItemsPerPage] = useState(10);

  const dispatch = useAppDispatch();
  const {
    status,
    employees,
    errorMessage,
    current_page,
    next_page_url,
    prev_page_url,
    total,
    per_page,
    data,
  } = useAppSelector((state) => state.employee);
  console.log({ data });

  useEffect(() => {
    dispatch(getEmployees({ page: 1, per_page: itemsPerPage }));
    dispatch(getAllCampaigns());
    dispatch(getRoles({}));
  }, [itemsPerPage]);

  useEffect(() => {
    if (status === "assingBrands_success") {
      dispatch(
        getEmployees({ page: 1, search: search.value, per_page: itemsPerPage }),
      );
    } else if (status === "assingRoles_success") {
      dispatch(
        getEmployees({ page: 1, search: search.value, per_page: itemsPerPage }),
      );
      Swal.fire({ title: "Roles assigned", icon: "success" });
    }
  }, [status]);

  useEffect(() => {
    if (status === "resendInvite_success") {
      Swal.fire({
        text: "Invitation send",
        icon: "success",
        confirmButtonColor: "#f03361",
      });
    }
  }, [status]);

  useEffect(() => {
    if (status === "importEmployees_success") {
      Swal.fire({
        icon: "success",
        title: "Import Completed Successfully",
        html: `
          <div style="text-align: center; padding: 10px;">
            <p style="margin: 15px 0; font-size: 16px; color: #2e7d32;">
              The Excel file has been imported successfully!
            </p>
            <p style="margin: 10px 0; font-size: 14px; color: #666;">
              All records have been processed and added to the system.
            </p>
          </div>
        `,
        confirmButtonColor: "#f03361",
        confirmButtonText: "OK",
      }).then((isConfirmed) => {
        if (isConfirmed.dismiss || isConfirmed.isConfirmed) {
          dispatch(getEmployees({ page: 1, per_page: itemsPerPage }));
          ToggleModal();
        }
      });
    } else if (status === "importEmployees_rejected") {
      // Verificar si es éxito parcial
      let isPartialSuccess = false;
      let processedCount = 0;

      if (data && typeof data === "string") {
        const match = data.match(/^Processed records (\d+)/);
        if (match && parseInt(match[1]) > 0) {
          isPartialSuccess = true;
          processedCount = parseInt(match[1]);
        }
      }

      const hasErrors = Array.isArray(errorMessage) && errorMessage.length > 0;
      const errorList = Array.isArray(errorMessage) ? errorMessage : [];

      // Función para generar contenido HTML según el caso
      const generateAlertContent = () => {
        let content = "";

        if (isPartialSuccess) {
          // Caso 2: Éxito parcial - algunos registros se importaron, otros con errores
          content += `
            <div style="text-align: left; padding: 15px;">
              <div style="margin: 15px 0; padding: 15px; background-color: #e8f5e9; border-left: 4px solid #4caf50; border-radius: 4px;">
                <p style="margin: 0; font-size: 15px; color: #2e7d32; font-weight: 500;">
                  ✓ ${processedCount} record${processedCount > 1 ? "s were" : " was"} successfully imported
                </p>
              </div>
              ${hasErrors
              ? `
                <div style="margin: 15px 0; padding: 15px; background-color: #fff3cd; border-left: 4px solid #ff9800; border-radius: 4px;">
                  <p style="margin: 0; font-size: 15px; color: #856404; font-weight: 500;">
                    ⚠️ ${errorList.length} record${errorList.length > 1 ? "s" : ""} could not be processed
                  </p>
                </div>
              `
              : ""
            }
          `;
        } else {
          // Caso 3: Error total - ningún registro se pudo importar
          content += `
            <div style="margin-bottom: 20px; padding: 15px; background-color: #ffebee; border-left: 4px solid #f44336; border-radius: 4px; text-align: left;">
              <p style="margin: 0; font-size: 15px; color: #c62828; font-weight: 500;">
                ✗ No records could be imported
              </p>
            </div>
          `;

          // Agregar mensaje general del servidor si existe
          if (data && typeof data === "string") {
            content += `
              <div style="margin-bottom: 20px; padding: 15px; background-color: #fff3cd; border-left: 4px solid #ffc107; border-radius: 4px; text-align: left;">
                <p style="margin: 0; font-size: 14px; color: #856404;">
                  ${data}
                </p>
              </div>
            `;
          }
        }

        // Agregar tabla de errores si existen
        if (hasErrors) {
          content += `
            <div style="margin: 15px 0; text-align: left;">
              <p style="margin: 0 0 10px 0; font-size: 14px; font-weight: 600; color: #d32f2f;">
                ${isPartialSuccess ? "Records with Errors" : "Error Details"} (${errorList.length}):
              </p>
            </div>
            <div style="max-height: 300px; overflow-y: auto; overflow-x: auto; border: 1px solid #ddd; border-radius: 4px;">
              <table style="width: 100%; border-collapse: collapse; text-align: left;">
                <thead>
                  <tr style="background-color: #f5f5f5; position: sticky; top: 0; z-index: 1;">
                    <th style="padding: 12px; border-bottom: 2px solid #ddd; font-weight: 600; color: #424242;">#</th>
                    <th style="padding: 12px; border-bottom: 2px solid #ddd; font-weight: 600; color: #424242;">Error Description</th>
                  </tr>
                </thead>
                <tbody>
                  ${errorList
              .map(
                (error: any, index: number) => `
                      <tr style="border-bottom: 1px solid #eee; background-color: ${index % 2 === 0 ? "#fff" : "#fafafa"};">
                        <td style="padding: 10px; border-right: 1px solid #eee; min-width: 50px; text-align: center; font-weight: 500; color: #666;">${index + 1}</td>
                        <td style="padding: 10px; color: #424242; line-height: 1.4;">${error}</td>
                      </tr>
                    `,
              )
              .join("")}
                </tbody>
              </table>
            </div>
            <div style="margin-top: 12px; padding: 10px; background-color: #f5f5f5; border-radius: 4px; text-align: left;">
              <p style="margin: 0; font-size: 12px; color: #666;">
                💡 <strong>Tip:</strong> ${isPartialSuccess
              ? "Please correct the errors in your Excel file and import again to add the remaining records."
              : "Please review and correct all errors in your Excel file before trying to import again."
            }
              </p>
            </div>
          `;
        }

        return content + "</div>";
      };

      // Determinar el icono y título según el caso
      const alertIcon = isPartialSuccess ? "warning" : "error";
      const alertTitle = isPartialSuccess
        ? "Incomplete Import"
        : "Import Failed";

      Swal.fire({
        icon: alertIcon,
        title: alertTitle,
        html: generateAlertContent(),
        width: "700px",
        heightAuto: false,
        confirmButtonColor: "#f03361",
        confirmButtonText: "Close",
        customClass: {
          htmlContainer: "swal-error-table",
          popup: "swal-import-popup",
        },
      }).then((isConfirmed) => {
        if (isConfirmed.isConfirmed || isConfirmed.isDismissed) {
          dispatch(resetEmployeeStatus());
          if (isPartialSuccess) {
            dispatch(getEmployees({ page: 1, per_page: itemsPerPage }));
            ToggleModal();
          }
        }
      });
    }
  }, [status]);

  const searchAction = () => {
    dispatch(
      getEmployees({ page: 1, search: search.value, per_page: itemsPerPage }),
    );
  };

  const onSearchKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      dispatch(
        getEmployees({ page: 1, search: search.value, per_page: itemsPerPage }),
      );
    }
  };

  const handleItemsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newPerPage = parseInt(e.target.value);
    setItemsPerPage(newPerPage);
    dispatch(
      getEmployees({ page: 1, search: search.value, per_page: newPerPage }),
    );
  };

  const importFile = async () => {
    ToggleModal();
  };

  const downloadFile = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/guardian/export/relations_brands_insurances`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "employees.xlsx";

        // Start download
        link.click();

        link.remove();
      });
  };

  // Debug functions for API testing

  return (
    <>
      <Modal
        isActive={isModalShown}
        clouse={ToggleModal}
        title="Import your employees"
      >
        <FileImport toggle={ToggleModal} status={status} />
      </Modal>
      <div className="c-table">
        <div className="c-table__header">
          <div className="c-table__box-options">
            <label className="c-table__search">
              <BsSearch />
              <input {...search} onKeyDown={(e) => onSearchKey(e)} />
            </label>
            <button
              className="c-table__button-secondary"
              onClick={searchAction}
            >
              Search
            </button>
          </div>
          {skills.includes("public.users.employees.create") ||
            skills.includes("super.admin") ||
            skills.includes("admin.employee.send.invitations") ||
            skills.includes("admin.employee.manager.export") ||
            skills.includes("admin.employee.manager.import") ? (
            <div className="c-table__box-options">
              {/* <button type="button" className="c-table__button-secondary">
              <RiFilter2Fill />
              Filter
            </button> */}
              {(skills.includes("public.users.employees.create") ||
                skills.includes("super.admin") ||
                skills.includes("admin.employee.send.invitations")) && (
                  <SendInviteButton />
                )}
              {(skills.includes("public.users.employees.create") ||
                skills.includes("super.admin") ||
                skills.includes("admin.employee.manager.export")) && (
                  <button
                    type="button"
                    className="c-table__button-secondary"
                    onClick={downloadFile}
                  >
                    <BiExport />
                    Export
                  </button>
                )}
              {(skills.includes("public.users.employees.create") ||
                skills.includes("super.admin") ||
                skills.includes("admin.employee.manager.import")) && (
                  <button
                    type="button"
                    className="c-table__button-primary"
                    onClick={importFile}
                  >
                    <BiImport />
                    Import
                  </button>
                )}
            </div>
          ) : null}
        </div>

        <table className="c-table__content">
          <thead>
            <tr>
              <td className="c-table__trheead">Employee</td>
              <td className="c-table__trheead">Status</td>
              <td className="c-table__trheead">Code</td>
              <td className="c-table__trheead">Brand</td>
              <td className="c-table__trheead">Actions</td>
            </tr>
          </thead>
          <tbody>
            {status === "getEmployees_loading" && (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    padding: "15px 30px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  Loading
                  <span
                    style={{
                      animation: "dot1 0.8s infinite",
                      opacity: 0,
                      animationDelay: "0s",
                    }}
                  >
                    .
                  </span>
                  <span
                    style={{
                      animation: "dot2 0.8s infinite",
                      opacity: 0,
                      animationDelay: "0.1s",
                    }}
                  >
                    .
                  </span>
                  <span
                    style={{
                      animation: "dot3 0.8s infinite",
                      opacity: 0,
                      animationDelay: "0.2s",
                    }}
                  >
                    .
                  </span>
                </div>
                <style>
                  {`
                    @keyframes dot1 {
                      0%, 20% { opacity: 0; transform: scale(0); }
                      40%, 100% { opacity: 1; transform: scale(1); }
                    }
                    @keyframes dot2 {
                      0%, 40% { opacity: 0; transform: scale(0); }
                      60%, 100% { opacity: 1; transform: scale(1); }
                    }
                    @keyframes dot3 {
                      0%, 60% { opacity: 0; transform: scale(0); }
                      80%, 100% { opacity: 1; transform: scale(1); }
                    }
                  `}
                </style>
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
                <Skeletontable />
              </>
            )}
            {status !== "getEmployees_loading" &&
              employees.map((employee, index) => (
                <Oneempleyee
                  key={employee.id_encrypted}
                  employee={employee}
                  index={index}
                />
              ))}
          </tbody>
        </table>
        {/* <Footertable /> */}
        <Footertable
          total={total}
          per_page={per_page}
          current_page={current_page}
          next_page_url={next_page_url}
          prev_page_url={prev_page_url}
          method={getEmployees}
          status={status}
          search={search.value}
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
    </>
  );
};

export default Employee;

interface PropsPagination {
  total: number;
  per_page: number;
  current_page: number;
  next_page_url: string | null;
  prev_page_url?: string | null;
  method: any;
  status: string;
  search?: any;
  itemsPerPage: number;
  onItemsPerPageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const MAX_PAGES_TO_SHOW = 5;
export const ELLIPSIS = "...";

type PaginationRange = (number | string)[];

export const generatePagination = (
  currentPage: number,
  totalPages: number,
): PaginationRange => {
  if (totalPages <= MAX_PAGES_TO_SHOW)
    return generateSimplePagination(totalPages);

  if (currentPage <= MAX_PAGES_TO_SHOW) return generateFirstPages();

  const lastPageGroupStart = calculateLastPageGroupStart(totalPages);
  if (currentPage >= lastPageGroupStart)
    return generateLastPages(lastPageGroupStart, totalPages);

  return generateMiddlePages(currentPage, totalPages);
};

const generateSimplePagination = (totalPages: number): PaginationRange => {
  return Array.from({ length: totalPages }, (_, i) => i + 1);
};

const generateFirstPages = (): PaginationRange => {
  return [
    ...Array.from({ length: MAX_PAGES_TO_SHOW }, (_, i) => i + 1),
    ELLIPSIS,
  ];
};

const calculateLastPageGroupStart = (totalPages: number): number => {
  return (
    Math.floor((totalPages - 1) / MAX_PAGES_TO_SHOW) * MAX_PAGES_TO_SHOW + 1
  );
};

const generateLastPages = (
  lastPageGroupStart: number,
  totalPages: number,
): PaginationRange => {
  const pagesToShow = Array.from(
    { length: totalPages - lastPageGroupStart + 1 },
    (_, i) => lastPageGroupStart + i,
  );
  return [ELLIPSIS, ...pagesToShow];
};

const generateMiddlePages = (
  currentPage: number,
  totalPages: number,
): PaginationRange => {
  const start =
    Math.floor((currentPage - 1) / MAX_PAGES_TO_SHOW) * MAX_PAGES_TO_SHOW + 1;
  const end = Math.min(start + MAX_PAGES_TO_SHOW - 1, totalPages);

  return [
    ELLIPSIS,
    ...Array.from({ length: end - start + 1 }, (_, i) => start + i),
    ELLIPSIS,
  ];
};

const Footertable = ({
  current_page,
  next_page_url,
  prev_page_url,
  method,
  status,
  search,
  total,
  per_page,
  itemsPerPage,
  onItemsPerPageChange,
}: PropsPagination) => {
  const dispatch = useAppDispatch();

  const nextPage = () => {
    if (current_page === Math.ceil(total / per_page)) return;
    if (search !== "") {
      dispatch(
        method({
          page: current_page + 1,
          search: search,
          per_page: itemsPerPage,
        }),
      );
    } else {
      dispatch(method({ page: current_page + 1, per_page: itemsPerPage }));
    }
  };

  const previousePage = () => {
    if (current_page === 1) return;
    if (search !== "") {
      dispatch(
        method({
          page: current_page - 1,
          search: search,
          per_page: itemsPerPage,
        }),
      );
    } else {
      dispatch(method({ page: current_page - 1, per_page: itemsPerPage }));
    }
  };

  const goPage = (page: number) => {
    if (search !== "") {
      dispatch(method({ page: page, search: search, per_page: itemsPerPage }));
    } else {
      dispatch(method({ page: page, per_page: itemsPerPage }));
    }
  };

  const allPages = useMemo(() => {
    return generatePagination(current_page, Math.ceil(total / per_page));
  }, [current_page, total, per_page]);

  const handlePageClick =
    (page: string | number, index: number, allPages: (string | number)[]) =>
      () => {
        console.log({ allPages });
        const createPageIndex = () => {
          if (page === "..." && index === allPages.length - 1) {
            return Number(allPages[allPages.length - 2]) + 1;
          }
          if (page === "...") {
            return Number(allPages[1]) - 1;
          }
          return Number(page);
        };
        goPage(createPageIndex());
      };

  if (
    status === "getEmployees_loading" ||
    status === "getRoles_pending" ||
    status === "getSkills_pending"
  ) {
    return null;
  }

  return (
    <div className="c-table__footer">
      <div className="c-table__per-page">
        <label htmlFor="itemsPerPage">Items per page:</label>
        <select
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={onItemsPerPageChange}
          className="c-table__select"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <div className="c-table__box-pagination">
        <div
          className={`c-table__option-pagination ${current_page === 1 ? "c-table__option-pagination--disabled" : ""
            }`}
          onClick={previousePage}
        >
          <BiChevronLeft />
        </div>
        {allPages.map((item, index) => {
          const position = index === 0 ? "start" : "end";
          const key =
            item === ELLIPSIS ? `ellipsis-${position}` : `page-${item}`;
          const active = item === current_page;

          return (
            <div
              key={key}
              className={`c-table__number-pagination ${active ? "c-table__number-pagination--active" : ""
                }`}
              onClick={handlePageClick(item, index, allPages)}
            >
              {item}
            </div>
          );
        })}
        <div
          className={`c-table__option-pagination ${current_page === Math.ceil(total / per_page)
              ? "c-table__option-pagination--disabled"
              : ""
            }`}
          onClick={nextPage}
        >
          <BiChevronRight />
        </div>
      </div>
    </div>
  );
};
